<template lang="html">
  <form role="form" @submit.prevent>
    <pre-loader v-show="!model.loaded"></pre-loader>
    <template v-if="model.loaded">
      <payout-form-group :label="$t('Код подтверждения из SMS') + ''"
                         :required="true"
                         :has-errors="model.errors.has('verificationData')">
        <input type="text" class="form-control"
               name="verificationData"
               :disabled="isLoading"
               @keydown.enter.prevent="submit"
               v-model="model.values.verificationData"/>
        <error-message attribute="verificationData|*" :errors="model.errors"></error-message>
      </payout-form-group>

      <div class="text-center" style="margin-top: 2em;">
        <ctrl-button href="#"
                     :disabled="isLoading"
                     :btn-label="btnBackLabel"
                     @click.native.prevent="goBack"
                     class="btn-warning"></ctrl-button>
        &nbsp;&nbsp;&nbsp;
        <ctrl-button href="#"
                     @click.native.prevent="submit"
                     :disabled="isLoading"
                     class="btn-success"
                     :btn-label="btnNextLabel">
        </ctrl-button>
      </div>
    </template>
  </form>
</template>

<script lang="ts">
// import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import AbstractPayoutVerification
  from '@/components/payout/verification/AbstractPayoutVerification.vue';
// import {VerificationModel} from "@/models/verification/payout";

@Component({
  //extends: AbstractPayoutVerification,
  name: 'verification-form-otp',
})
export default class PayoutVerificationOtp extends AbstractPayoutVerification {

  get inputSmsCode() {
    return (this.model.values.verificationData + '').trim();
  }

  @Watch("inputSmsCode")
  onInputSmsCode(newVal) {
    if (/^\d{6}$/.test(newVal))
      this.submit();
  }
}
</script>

<style scoped lang="less">

</style>

<i18n>
{
  "en": {
    "Код подтверждения из SMS": "SMS code"
  }
}
</i18n>
